import ConsentApi from '../../api/ConsentApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = {
  id: string;
};

export const getUserConsentStatus = createQueryFn(
  QueryNameSpace.getUserConsentStatus,
  async ({ queryKey }: QueryFunctionContext<[string] | [string, Params]>) => {
    const [, params] = queryKey;

    const res = await ConsentApi.getUserConsentStatus(params.id);

    return res;
  },
);
